import React, { useEffect, useRef, useState } from 'react';
// import { ReactComponent as LogoSvg } from 'assets/svg/logo.svg';
import LogoImg from 'assets/image/LOGO - Horizontal.png';
import LogoImgHorizontal from 'assets/image/LOGO - Icon.png'
import { ReactComponent as SearchIcon } from 'assets/svg/searchIcon.svg';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as MenuIcon } from 'assets/svg/menuIcon.svg';
import { ReactComponent as CloseIcon } from 'assets/svg/close.svg';
import RoundedButton from 'components/RoundedButtons';
import { useDispatch, useSelector } from 'react-redux';
import Login from 'pages/Login/Login';
import { setDialogState } from 'reduxStore/reducers/dialogSlice';
import NewPassword from 'pages/NewPassword/NewPassword';
import ResetPassword from 'pages/ResetPassword/ResetPassword';
import { isLoggedIn } from 'utils/helpers';
import userPlaceholder from 'assets/image/userPlaceholder.png';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../reduxStore/actions/auth';
import { clearStorage } from 'utils/storage';
import { setToken } from '../../reduxStore/reducers/userSlice';
import Modal from '../../pages/Setting/components/Model';
import LoginOtp from 'pages/Login/component/LoginOtp';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();
  const profileMenuRef = useRef();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.userSlice);
  const [showModel, setShowModel] = useState({
    logoutModel: false,
  });

  const navItems = [
    { id: 'home', name: 'Home', path: '/' },
    { id: 'pregnancy', name: 'Pregnancy', path: '/pregnancy' },
    { id: 'baby', name: 'Baby', path: '/baby' },
    { id: 'parenthood', name: 'Parenthood', path: '/parenthood' },
    { id: 'family', name: 'Family', path: '/family' },
    { id: 'community', name: 'Community', path: '/community?tab=1' },
    // { id: 'courses', name: 'Courses', path: '/courses' },
    { id: 'blog', name: 'Blog', path: '/blogs' },
  ];

  const { dialogOpenState } = useSelector((state) => state.dialogOpenState);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = () => {
    navigate('/search');
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (e, item) => {
    // Only check login for Community, Courses, and Blog
    const protectedMenus = ['community', 'courses'];
    
    if (protectedMenus.includes(item.id)) {
      // If user is not logged in, show login modal and prevent navigation
      if (!isLoggedIn()) {
        e.preventDefault();
        dispatch(
          setDialogState({
            ...dialogOpenState,
            logIn: true,
            register: false,
          })
        );
        // Close mobile menu if open
        setIsMenuOpen(false);
      }
    }
    // For all other menu items, allow normal navigation
  };

  const handleLogoutClick = () => {
    setShowModel({ logoutModel: false }); 
    dispatch(logoutUser())
      .unwrap()
      .then((response) => {
        if (response.success) {
          clearStorage();
          dispatch(setToken(null));
          window.location.reload();
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }

      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target) &&
        !showModel.logoutModel // Don't close profile menu if logout modal is open
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef, profileMenuRef, showModel.logoutModel]);

  
  const handleShowLogoutModal = () => {
    setShowModel({ logoutModel: true });
    setMenuOpen(false);
  };


  return (
    <header className='sticky w-full z-20 top-0'>
      <nav className='w-full z-20 start-0 pt-4  pb-3 sm:pb-5'>
        <div className='container'>
          <div className='flex  items-center justify-between mx-auto py-2 pl-4 pr-2 shadow-primary-shadow rounded-full bg-blur'>
            <Link 
              to={'/'}
              onClick={(e) => {
                if (location.pathname === '/') {
                  e.preventDefault();
                  window.location.reload();
                }
              }}
            >
              <img src={LogoImg} alt='Prega Center logo' className='h-10 w-auto hidden xxs:block' />
              <img src={LogoImgHorizontal} alt='Prega Center logo' className='h-10 w-auto block xxs:hidden' />

            </Link>
            
            <div className='flex items-center md:order-2 space-x-3 md:space-x-0'>
              <div className='flex gap-2 sm:gap-5 items-center'>
                <SearchIcon onClick={handleSearch} className='cursor-pointer' />
                {isLoggedIn() ? (
                  <div ref={profileMenuRef} className='relative'>
                    <img
                      src={
                        currentUser?.profile_image
                          ? currentUser?.profile_image
                          : userPlaceholder
                      }
                      alt='profile'
                      className='size-10 md:size-[52px] rounded-full p-0.5 md:p-1 border-2 border-primary object-cover cursor-pointer'
                      onClick={toggleMenu}
                    />
                    {menuOpen && (
                      <div className='absolute right-0 mt-2 w-[216px] rounded-2xl bg-white shadow-lg p-5'>
                        <button
                          className='block px-4 py-2 text-navy-blue-dark text-base font-medium hover:bg-gray-100 w-full text-left'
                          onClick={() => {
                            navigate('/setting');
                            setMenuOpen(false);
                          }}
                        >
                          Account & Settings
                        </button>
                        <button
                          className='block px-4 py-2 text-navy-blue-dark text-base font-medium hover:bg-gray-100 w-full text-left'
                          onClick={() => {
                            navigate('/baby/names/savednames');
                            setMenuOpen(false);
                          }}
                        >
                          My Baby Name List
                        </button>
                        <button
                          className='block px-4 py-2 text-primary text-base font-medium hover:bg-gray-100 w-full text-left'
                          onClick={handleShowLogoutModal}
                        >
                          Logout
                        </button>
                      </div>

                    )}

                  </div>
                ) : (
                  <RoundedButton
                    onClick={() => {
                      dispatch(
                        setDialogState({
                          ...dialogOpenState,
                          logIn: true,
                          register: false,
                        })
                      );
                    }}
                    text='Log In'
                    className='bg-primary text-shade_blue_black whitespace-nowrap'
                  />
                )}
                <MenuIcon
                  type='button'
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className='cursor-pointer inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg xl:hidden hover:bg-red-4 focus:outline-none focus:ring-2 focus:ring-red-5 '
                />
              </div>
            </div>

            <div
              className={
                'items-center justify-between w-full xl:flex xl:w-auto xl:order-1 hidden'
              }
              id='navbar-sticky'
            >
              <ul className='flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-transparent md:space-x-10 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0'>
                {navItems.map((item) => (
                  <NavLink
                    className={({ isActive }) =>
                      isActive
                        ? 'text-[16px] font-medium text-secondary'
                        : 'text-[16px] font-medium text-text-black hover:text-secondary'
                    }
                    key={item.id}
                    to={item.path}
                    onClick={(e) => handleNavClick(e, item)}
                  >
                    {item.name}
                  </NavLink>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </nav>
      {showModel.logoutModel && (
        <Modal
          title='Logout'
          text='Are you sure you want to logout?'
          children={
            <>
              <div className='flex flex-col gap-3.5'>
                <RoundedButton
                  text='Logout'
                  isWidthFull
                  className='bg-[#FF7373] text-shade_blue_black'
                  onClick={handleLogoutClick}
                />
                <RoundedButton
                  className='w-full font-semibold justify-center !bg-gray-1 bg-opacity-35 text-gray-3'
                  isWidthFull={true}
                  text="Cancel"
                  type='button'
                  onClick={() => {
                    setShowModel({ logoutModel: false });
                  }}
                />
              </div>
            </>
          }
          textClassName='text-[#FF7373]'
        />
      )}
      <div
        className={`xl:hidden ${isMenuOpen ? 'flex' : 'hidden'
          } flex-col w-full bg-white px-6 py-6 sm:max-w-sm inset-y-0 z-20 overflow-y-auto fixed right-0 gap-5`}
        role='dialog'
        id='navbar-sticky'
        aria-modal='true'
        ref={menuRef}
      >
        <div className='flex justify-between items-center'>
          <div className='flex gap-4 items-center'>
            <Link 
              to={'/'} 
              onClick={(e) => {
                setIsMenuOpen(false);
                if (location.pathname === '/') {
                  e.preventDefault();
                  window.location.reload();
                }
              }}
            >
              <img src={LogoImg} alt='Prega Center logo' className='h-10 w-auto' />

            
            </Link>
            {/* <h1 className='text-xl font-bold'> Prega Center</h1> */}
          </div>
          <button
            className='inline-flex items-center p-2 w-8 h-8 justify-center text-sm text-gray-500 rounded-full hover:bg-red-4 focus:outline-none focus:ring-2 focus:ring-red-5 '
            onClick={() => setIsMenuOpen(false)}
          >
            <CloseIcon />
          </button>
        </div>
        <ul className='flex flex-col md:p-0 font-medium md:flex-col md:mt-0 md:border-0'>
          {navItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.path}
              className={({ isActive }) =>
                isActive
                  ? 'p-3 rounded-lg bg-primary text-white'
                  : 'p-3 rounded-lg hover:bg-primary hover:text-white'
              }
              onClick={(e) => {
                handleNavClick(e, item);
                // Close menu if navigation is allowed (user is logged in or it's not a protected menu)
                const protectedMenus = ['community', 'courses', 'blog'];
                if (isLoggedIn() || !protectedMenus.includes(item.id)) {
                  setIsMenuOpen(false);
                }
              }}
            >
              {item.name}
            </NavLink>
          ))}
          
        </ul>
      </div>
      {(dialogOpenState.logIn || dialogOpenState.register) && <Login />}
      {dialogOpenState.newPassword && <NewPassword />}
      {(dialogOpenState.resetPassword || dialogOpenState.otp) && (
        <ResetPassword />
      )}
      {dialogOpenState.isLoginOtp && <LoginOtp />}
    </header>

  );
};

export default Header;
